import { ReactNode } from 'react'
import styled from '@emotion/styled'

import { Flex } from '../Flex'
import { Headline2 } from '../Typography'

const Wrapper = styled(Flex)`
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  justify-content: space-between;
`

export default function SubRouteTitle({
  title,
  backButton,
  actionButton,
}: {
  title: ReactNode
  backButton?: JSX.Element
  actionButton?: JSX.Element
}) {
  return (
    <Wrapper>
      <Flex>
        {backButton ? (
          backButton
        ) : (
          <Flex style={{ visibility: 'hidden', minWidth: 40 }} />
        )}
      </Flex>
      <Flex>
        <Headline2>{title}</Headline2>
      </Flex>
      <Flex>
        {actionButton ? (
          actionButton
        ) : (
          <Flex style={{ visibility: 'hidden', minWidth: 40 }} />
        )}
      </Flex>
    </Wrapper>
  )
}
